import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { TickerRibbon } from "@/components/TickerRibbon";
import { Hero } from "@/components/Hero";
import { Academy } from "@/components/Academy";
import { Pricing } from "@/components/Pricing";
import { Footer } from "@/components/Footer";
import { AuthModal } from "@/components/AuthModal";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function Landing() {
  const [authOpen, setAuthOpen] = useState(false);
  const [rates, setRates] = useState({});
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/tools/rates").then(({ data }) => setRates(data.rates || {})).catch(() => {});
  }, []);

  useEffect(() => {
    // scroll to hash target when arriving from another route (e.g. /#pricing)
    if (window.location.hash && window.location.hash.length > 1) {
      const id = window.location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);

  const requireAuth = () => setAuthOpen(true);
  const goAnalyze = () => (user ? navigate("/dashboard") : setAuthOpen(true));

  return (
    <div className="min-h-screen bg-[#070A0E] text-white">
      <Navbar onAuthClick={() => setAuthOpen(true)} />
      <TickerRibbon rates={rates} />
      <Hero onAnalyze={goAnalyze} onJoin={() => setAuthOpen(true)} />
      <Academy onJoin={() => setAuthOpen(true)} />
      <Pricing onRequireAuth={requireAuth} />
      <Footer />
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} />
    </div>
  );
}
